import { useRef } from 'react'

export const ThunderIcon = ({ className }: { className?: string }) => {
  const gradientId = useRef<string>(typeof window !== 'undefined' ? window.crypto.randomUUID() : '')

  return (
    <svg
      width='16'
      height='25'
      viewBox='0 0 16 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.83105 0.634089C10.7621 -0.669377 12.814 0.198283 12.5275 1.77427L11.1414 9.39756H15.8117L6.06744 24.014C5.17088 25.3588 3.07406 24.5296 3.33977 22.9353L4.76273 14.3976H0L9.83105 0.634089Z'
        fill={`url(#${gradientId.current})`}
      />
      <defs>
        <linearGradient
          id={gradientId.current}
          x1='14'
          y1='2'
          x2='-22.0586'
          y2='40.2022'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFD670' />
          <stop offset='0.236954' stopColor='#FFCD3D' />
          <stop offset='1' stopColor='#FD6533' />
        </linearGradient>
      </defs>
    </svg>
  )
}
